/**
 * Label for "Top 3 risks" — finding-oriented, not aspirational rule titles.
 * Keep in sync with server/utils/topRiskLabel.js.
 */
export function topRiskDisplayLabel(finding) {
  if (!finding || typeof finding !== "object") return "Risk";

  const title = finding.title != null ? String(finding.title).trim() : "";
  const rawMsg = finding.message != null ? String(finding.message).trim() : "";
  if (rawMsg) return trimForTopRisk(rawMsg);

  let d = finding.detail != null ? String(finding.detail).trim() : "";
  if (d) {
    const cutExp = d.indexOf(" · Expected:");
    if (cutExp >= 0) d = d.slice(0, cutExp).trim();
    const cutRem = d.indexOf(" · Remediation:");
    if (cutRem >= 0) d = d.slice(0, cutRem).trim();
    if (d) return trimForTopRisk(d);
  }

  if (title) return `Not yet: ${title}`;
  return "Risk";
}

function trimForTopRisk(s, max = 220) {
  const t = String(s).trim();
  if (t.length <= max) return t;
  return `${t.slice(0, max - 1).trimEnd()}…`;
}
